import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CallButton from './components/CallButton';
import ScrollToTopButton from './components/ScrollToTopButton';
import ChatWidget from './components/ChatWidget';
import Home from './pages/Home';
import About from './pages/About';
import PropertyDetails from './pages/PropertyDetails';
import CategoryProperties from './pages/CategoryProperties';
import Blogs from './pages/Blogs';
import BuySell from './pages/BuySell';
import GalleryDetail from './pages/GalleryDetail';
import Leadership from './pages/Leadership';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import CallLog from './pages/CallLog';
import ChoiceCategoryProperties from './pages/ChoiceCategoryProperties';
import ListProperty from './pages/ListProperty';
import Guide from './pages/Guide';
import Profile from './pages/Profile';

// Disable browser's built-in scroll restoration — we handle it ourselves
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Detail/form pages always open at the top
    const alwaysScrollToTop = /^\/(property|gallery|about|contact|careers|blogs|buy-sell|guide|list-property|profile|call-log|category|choice-category)/.test(location.pathname);

    // Home manages its own scroll when restoreScrollId is set
    const hasRestoreTarget = !!(sessionStorage.getItem('restoreScrollId') || sessionStorage.getItem('homeRestoreId'));

    if (alwaysScrollToTop) {
      window.scrollTo(0, 0);
    } else if (!hasRestoreTarget) {
      window.scrollTo(0, 0);
    }
    // If hasRestoreTarget, Home.js will handle scrolling via pageshow / mount effect
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/property/:id" element={<PropertyDetails />} />
            <Route path="/category/:category" element={<CategoryProperties />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/buy-sell" element={<BuySell />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/gallery/:id" element={<GalleryDetail />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/call-log" element={<CallLog />} />
            <Route path="/choice-category/:category" element={<ChoiceCategoryProperties />} />
            <Route path="/list-property" element={<ListProperty />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
          <Footer />
          <div className="fixed bottom-4 right-4 z-50 flex flex-col items-center gap-3 bg-transparent p-0">
            <ScrollToTopButton inline />
            <ChatWidget inline />
            <CallButton inline />
            <WhatsAppButton inline />
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
